import { HousePresetData } from '@src/store/ifl-house';
import { Risk } from '@src/types';

export const createRisksFromPresetData = (
  presetData: HousePresetData,
  risks: Risk[]
): Risk[] => {
  const codes = presetData.risks;

  return risks.map((risk: Risk) => ({
    ...risk,
    active: codes.includes(risk.code),
  }));
};
